import { render, staticRenderFns } from "./rechargerecord.vue?vue&type=template&id=2b9cf14c"
import script from "./rechargerecord.vue?vue&type=script&lang=js"
export * from "./rechargerecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports